import React from 'react'
import { Header as CommonHeader } from '@LTIDashboard/modules/common'
import { ReturnButton } from '@LTIDashboard/modules/SubmissionsDashboard/Header'
import { SubHeader } from '@LTIDashboard/modules/SubmissionsDashboard/Header'

export function Header({ assessment }) {
  return (
    <React.Fragment>
      <ReturnButton />
      <CommonHeader title={assessment.title} status={assessment.aggregateStatus} />
      <SubHeader status={assessment.individualStatusItems} assignmentPK={assessment.pk} />
    </React.Fragment>
  )
}
